import React, { useState } from 'react'
import Loader from '../../../composed/Loader/Loader'
import fallBackImage from '../../../global/assets/png/clock-blue.png'
import { CELEBRITY_CHEF_SUB_TEXT } from "../../../global/constants";
import { TEST_FOOD_1_JPG, TEST_FOOD_2_JPG, TEST_FOOD_3_JPG } from "../../../global/assets/Icons";
import { MealOfferingCalculation } from './../../../global/calculations';
import { Chip } from '@mui/material';



const CelebrityChef = (props) => {
    const { celebrityChefList, handleClickRedirect, customerInfoData } = props
    const [imageLoaded, setImageLoaded] = useState([])
    const [imageError, setImageError] = useState([])
    // console.log('----celebrityChefList 33', celebrityChefList)
    const { loading, data, success, errorMessage } = customerInfoData
    const custInfoData = data?.data || [];
    const custMealPlan = custInfoData?.meal_Package?.meal_plan;



    const onImageLoad = (index) => {
        setImageLoaded((prev) => {
            prev[index] = true;
            return [...prev];
        })

    }

    const onImageError = (index) => {
        setImageError((prev) => {
            prev[index] = true;
            return [...prev];
        })

        setImageLoaded((prev) => {
            prev[index] = true;
            return [...prev];
        })
    }

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column', width: '700px', height: 'auto',
            marginBottom: '25px', marginTop: '10px', position: 'relative',
            border: '2px solid #181436', borderRadius: '5px',
            cursor: 'pointer',

        }}>

            {celebrityChefList.map((el, index) => (
                <div style={{ cursor: 'pointer', }} key={el.kitchenName} onClick={(e) => handleClickRedirect(e, el)}>
                    <div style={{ display: 'flex', flexDirection: 'row', height: '70px', width: '100%', borderBottom: '1px solid #F1F1F1', cursor: 'pointer', }}>
                        <div style={{ width: "75%" }}>
                            <div style={{ color: '#181436', marginLeft: '15px', fontStyle: 'normal', fontWeight: 600, fontSize: '16px', marginTop: '15px' }}>Celebrity Chef </div>
                            <div style={{ color: '#181436', marginLeft: '15px', fontWeight: 400, fontSize: '12px', marginTop: '1px', marginBottom: '10px' }}>{CELEBRITY_CHEF_SUB_TEXT}</div>
                        </div>
                        <div style={{ width: "22%" }}>
                            <Chip label={`Oct 10th - Oct 16th`}
                                size='small' sx={{ width: '100%', height: '25px', borderRadius: '5px', border: '1px solid #FF893A', background: '#FF893A', color: '#FFF3EA', fontWeight: 500, fontSize: '12px', margin: '15px 10px 3px 0px' }} />
                        </div>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'row', width: '100%', padding: '0px 0px 15px 0px' }}>
                        <div style={{ width: "35%" }}>
                            <div style={{
                                color: 'black',
                                marginLeft: '15px',
                                fontStyle: 'normal',
                                fontWeight: 500,
                                fontSize: '12px',
                                // marginTop: '05px',
                                height: '130px',
                                border: '3px solid white',
                                backgroundColor: 'white',
                                borderRadius: '5px',
                                display: 'flex',
                                alignItems: 'center', justifyContent: 'center', objectFit: 'cover', overflow: 'hidden'
                            }}>       <img
                                    width={imageLoaded[index] ? '100%' : 0}
                                    src={imageError[index] ? fallBackImage : el.display_image}
                                    onLoad={() => onImageLoad(index)}
                                    onError={() => onImageError(index)}
                                    key={el._id}
                                />
                                {!imageLoaded[index] &&
                                    <Loader color='black' width='20px' height='20px' />}

                            </div>
                            <div style={{
                                color: '#181436', marginLeft: '17px', fontWeight: 600,
                                fontSize: '14px',
                            }}>Gordon James Ramsay</div>
                            <div style={{
                                color: '#181436', marginLeft: '17px', fontWeight: 400,
                                fontSize: '12px', marginTop: '5px',
                                textAlign: 'left',
                            }}>
                                Gordon James Ramsay OBE is a British celebrity chef, restaurateur, television presenter, and writer. His restaurant group, Gordon Ramsay Restaurants, was founded in 1997 and has been awarded 17 Michelin stars overall and currently holds seven</div>
                        </div>
                        <div style={{ width: "100%", marginLeft: '15px', borderLeft: '1px solid #F1F1F1' }}>
                            <div style={{ color: '#FF893A', marginLeft: '15px', fontStyle: 'normal', fontWeight: 600, fontSize: '12px', marginTop: '15px' }}>Combo Items ( Per person )</div>
                            <div style={{ color: 'black', marginLeft: '15px', fontStyle: 'normal', fontWeight: 500, fontSize: '12px', marginTop: '3px' }}>1 Main dish + 1 Side</div>
                            <div style={{ display: 'flex', flexDirection: 'row' }}>
                                <div style={{ width: '150px', height: 'auto', borderRadius: '5px 5px 0px 0px', border: '1px solid #DBD6D6', margin: '10px 5px 0px 15px' }}>
                                    <div style={{
                                        // height: '160px',
                                        borderRadius: '5px 5px 0px 0px',
                                        overflow: 'hidden',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        objectFit: 'cover',
                                        // border: '1px solid red'
                                    }}>   <img
                                            width={imageLoaded[index] ? '100%' : 0}
                                            src={imageError[index] ? fallBackImage : TEST_FOOD_3_JPG}
                                            onLoad={() => onImageLoad(index)}
                                            onError={() => onImageError(index)}
                                            key={el._id}
                                        />
                                        {!imageLoaded[index] &&
                                            <Loader color='black' width='20px' height='20px' />}
                                    </div>
                                    <div style={{
                                        height: 'auto',
                                        // borderRadius: '5px 5px 0px 0px',
                                        overflow: 'hidden',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        flexWrap: 'wrap',
                                        borderTop: '1px solid #DBD6D6',
                                        padding: '5px'
                                    }}>
                                        <div style={{ fontFamily: 'Inter', fontStyle: 'normal', fontWeight: 600, fontSize: '10px', marginTop: '1px', marginLeft: '5px' }}> Home Chedf Name </div>
                                        <div style={{ fontFamily: 'Inter', fontStyle: 'normal', fontWeight: 300, fontSize: '10px', marginTop: '2px', marginLeft: '5px', color: 'gray' }}> Cooking pass 10 years Cooking pass 10 years Cooking pass 10 years </div>


                                    </div>

                                </div>
                                <div style={{ width: '150px', height: 'auto', borderRadius: '5px 5px 0px 0px', border: '1px solid #DBD6D6', margin: '10px 5px 0px 0px' }}>
                                    <div style={{
                                        // height: '160px',
                                        borderRadius: '5px 5px 0px 0px',
                                        overflow: 'hidden',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        objectFit: 'cover',
                                        // border: '1px solid red'
                                    }}> <img
                                            width={imageLoaded[index] ? '100%' : 0}
                                            src={imageError[index] ? fallBackImage : TEST_FOOD_2_JPG}
                                            onLoad={() => onImageLoad(index)}
                                            onError={() => onImageError(index)}
                                            key={el._id}
                                        />
                                        {!imageLoaded[index] &&
                                            <Loader color='black' width='20px' height='20px' />}
                                    </div>
                                    <div style={{
                                        height: 'auto',
                                        // borderRadius: '5px 5px 0px 0px',
                                        overflow: 'hidden',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        flexWrap: 'wrap',
                                        // alignItems: 'center',
                                        // justifyContent: 'center',
                                        borderTop: '1px solid #DBD6D6',
                                        padding: '5px'
                                        // backgroundColor: '#F8F8F8'
                                    }}>
                                        <div style={{ fontFamily: 'Inter', fontStyle: 'normal', fontWeight: 600, fontSize: '10px', marginTop: '1px', marginLeft: '5px' }}> Home Chedf Name </div>
                                        <div style={{ fontFamily: 'Inter', fontStyle: 'normal', fontWeight: 300, fontSize: '10px', marginTop: '2px', marginLeft: '5px', color: 'gray' }}> Cooking pass 10 years Cooking pass 10 years Cooking pass 10 years </div>


                                    </div>

                                </div>
                                <div style={{ width: '150px', height: 'auto', borderRadius: '5px 5px 0px 0px', border: '1px solid #DBD6D6', margin: '10px 5px 0px 0px' }}>
                                    <div style={{
                                        // height: '160px',
                                        borderRadius: '5px 5px 0px 0px',
                                        overflow: 'hidden',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        objectFit: 'cover',
                                        // border: '1px solid red'
                                    }}> <img
                                            width={imageLoaded[index] ? '100%' : 0}
                                            src={imageError[index] ? fallBackImage : TEST_FOOD_1_JPG}
                                            onLoad={() => onImageLoad(index)}
                                            onError={() => onImageError(index)}
                                            key={el._id}
                                        />
                                        {!imageLoaded[index] &&
                                            <Loader color='black' width='20px' height='20px' />}

                                    </div>
                                    <div style={{
                                        height: 'auto',
                                        // borderRadius: '5px 5px 0px 0px',
                                        overflow: 'hidden',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        flexWrap: 'wrap',
                                        // alignItems: 'center',
                                        // justifyContent: 'center',
                                        borderTop: '1px solid #DBD6D6',
                                        padding: '5px'
                                        // backgroundColor: '#F8F8F8'
                                    }}>
                                        <div style={{ fontFamily: 'Inter', fontStyle: 'normal', fontWeight: 600, fontSize: '10px', marginTop: '1px', marginLeft: '5px' }}> Home Chedf Name </div>
                                        <div style={{ fontFamily: 'Inter', fontStyle: 'normal', fontWeight: 300, fontSize: '10px', marginTop: '2px', marginLeft: '5px', color: 'gray' }}> Cooking pass 10 years Cooking pass 10 years Cooking pass 10 years </div>


                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            ))
            }

        </div>

    )
}

export default CelebrityChef